<div class="strategy-tabs">
  <div class="strategy-tabs-container">
    <div id="sl-tab-investment" class="tab-item" data-cy="strategy-tab-investment" [ngClass]="{ active: step === 1 }" (click)="tabNavigation(1)">
      <div>
        <span [ngClass]="getTabIcon(1)"></span>
        <p>{{ 'GROW.projects.selection.title' | translate }}</p>
        <p class="tab-label-mobile">{{ 'GROW.riskProfile.tabs.projects.headerMobile' | translate }}</p>
      </div>
    </div>
    <div
      id="sl-tab-investment"
      class="tab-item"
      data-cy="strategy-tab-investment"
      [ngClass]="{ disabled: step < 2, active: step === 2 }"
      (click)="tabNavigation(2)"
    >
      <div>
        <span [ngClass]="getTabIcon(2)"></span>
        <p>{{ 'GROW.riskProfile.amount.title' | translate }}</p>
        <p class="tab-label-mobile">{{ 'GROW.riskProfile.tabs.investmentAmount.headerMobile' | translate }}</p>
      </div>
    </div>
    <div id="sl-tab-investment" class="tab-item" [ngClass]="{ disabled: step < 3, active: step === 3 }" (click)="tabNavigation(3)">
      <div>
        <span [ngClass]="getTabIcon(3)"></span>
        <p>{{ 'GROW.riskProfile.profile.title' | translate }}</p>
        <p class="tab-label-mobile">{{ 'GROW.riskProfile.tabs.riskProfile.headerMobile' | translate }}</p>
      </div>
    </div>
  </div>
</div>
<div class="grow-risk-page">
  <div *ngIf="step === 1">
    <ng-container *ngIf="growAccount">
      <div class="heading">
        <div class="projects-title" [class.opened]="infoList['projectsInfo']">
          <h3 class="ds-title-3">{{ 'GROW.projects.selection.title' | translate }}</h3>
          <app-ds-icon name="info" class="info-icon" color="var(--color-core-neutral-5)" (click)="showInfo('projectsInfo')" />
        </div>
        <div class="projects-info" *ngIf="infoList['projectsInfo']">
          <p class="ds-ui-3 ds-color-core-neutral-7" [innerHTML]="'GROW.projects.selection.projectsInfo' | translate"></p>
        </div>
        <p class="ds-running-1">{{ 'GROW.projects.selection.description' | translate }}</p>
      </div>

      <app-grow-projects-list [growAccount]="growAccount" [selectedProjects]="selectedProjects?.length"></app-grow-projects-list>
    </ng-container>
  </div>

  <div *ngIf="step === 2">
    <ng-container *ngIf="growAccount">
      <app-grow-investment-amount
        class="investment-plan"
        [growAccount]="growAccount"
        [investmentPlanData]="investmentPlan"
        [initialInvestmentOptions]="[growAccount.minimum_investment, 5000, 10000, 50000]"
        [savingsPlanOptions]="[100, 500, 1000, 2000]"
        (formSubmitted)="onSubmitInvestmentAmount($event)"
      ></app-grow-investment-amount
    ></ng-container>
  </div>

  <div *ngIf="step === 3">
    <app-grow-risk-form
      hideInvestmentAmount="true"
      [investmentPlanData]="investmentPlan"
      [growAccount]="growAccount"
      [growRisk]="growRisk"
      [riskPercentages]="riskPercentages"
      [isSubmitLoading]="submitLoading$ | async"
      (changed)="onValuesChanged($event)"
      (formSubmitted)="onSubmit($event)"
      (riskInputError)="onRiskInputError()"
      [hideInvestCallout]="true"
      [hideCTA]="true"
      *ngIf="riskLoaded$ | async; else loadingState"
      #formComponent
    ></app-grow-risk-form>

    <ng-template #loadingState>
      <div class="skeleton-wrapper">
        <div class="skeleton title"></div>
        <div class="skeleton item"></div>
        <div class="skeleton item"></div>
        <div class="skeleton title"></div>
        <div class="skeleton item"></div>
        <div class="skeleton item"></div></div
    ></ng-template>
  </div>
</div>

<div class="loading-overlay" *ngIf="checkOrSubmitLoading$ | async">
  <app-loading-spinner></app-loading-spinner>
</div>

<app-footer class="grow-risk-footer" [hideGuarantee]="false">
  <div *ngIf="step === 1">
    <ng-container *ngIf="{ hasSelectedProject: hasSelectedProject$ | async } as o">
      <button class="ui-button" [ngClass]="{ secondary: !o.hasSelectedProject }" (click)="goToRisk()">
        @if (o.hasSelectedProject) {
          {{ 'GROW.projects.selection.continueBtn' | translate }}
        } @else {
          {{ 'GROW.projects.selection.skipBtn' | translate }}
        }
      </button>
    </ng-container>
  </div>
  <div *ngIf="step === 2">
    <ng-container>
      <button class="ui-button" (click)="onConfirmInvestmentAmount()">
        {{ 'GROW.projects.selection.continueBtn' | translate }}
      </button>
    </ng-container>
  </div>
  <div *ngIf="step === 3">
    <button
      class="ui-button attention grow-risk-cta"
      (click)="onConfirm()"
      [disabled]="checkOrSubmitLoading$ | async"
      [class.loading]="submitLoading$ | async"
      *ngIf="riskLoaded$ | async"
    >
      <span class="icon-i-windmill"></span>
      {{ 'cta_open_account' | translate }}
    </button>
  </div>
</app-footer>
